// service/own-attendance.ts

import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

export type InOutRecord = {
  _id: string
  type: "in" | "out"
  time: string
}

export type AttendanceRecord = {
  _id: string
  user: string
  employee?: string
  status: "present" | "absent" | "late" | "half-day" | "leave"|"off"
  shift?: string
  branch?: string
  markedBy?: string
  date: string
  inOut?: InOutRecord[]
  remarks?: string
  createdAt: string
  updatedAt: string
  __v?: number
late: { actual: number; effective: number }
early: { actual: number; effective: number }
}

export type AttendanceSummary = {
  totalDays: number
  presentDays: number
  absentDays: number
  lateDays: number
  halfDays: number
  leaveDays: number
  totalWorkingHours: string
  averageWorkingHours: string
  attendancePercentage: string
  presentPercentage: string
  absentPercentage: string
  latePercentage: string
  totalEffectiveLateMinutes: number
  totalLateHours: string
  totalEffectiveEarlyMinutes: number
  totalEarlyHours: string
  earlyDeductionDays: number
  lateDeductionDays: number;

}

export type AttendanceResponse = {
  success: boolean
  role: string
  person?: {
    type: "employee" | "student";
    name: string;
    code: string | null;
  };
  count: number                   
  data: AttendanceRecord[]
  report: {
    summary: AttendanceSummary
    overallPerformance: string
  }
}

const ATTENDANCE_ENDPOINT = {
  ATTENDANCE: "/attendance",
}

const getMyAttendance = async ({
  startDate,
  endDate,
  month,
}: {
  startDate?: string
  endDate?: string
  month?: string
} = {}) => {
  const response = await apiClient({
    url: appendQueryParams(ATTENDANCE_ENDPOINT.ATTENDANCE, {
      startDate,
      endDate,
      month,
    }),
    method: "GET",
  })
  return response.data as AttendanceResponse
}

// ✅ NEW: employee detail (report click)
export const getEmployeeAttendance = async ({
  employeeId,
  startDate,
  endDate,
  month,
}: {
  employeeId: string;
  startDate?: string;
  endDate?: string;
  month?: string;
}) => {
  const response = await apiClient({
    url: appendQueryParams(`/attendance/employee/${employeeId}`, {
      startDate,
      endDate,
      month,
    }),
    method: "GET",
  });
  return response.data as AttendanceResponse;
};

// ✅ NEW: student detail (report click)
export const getStudentAttendance = async ({
  enrollmentId,
  startDate,
  endDate,
  month,
}: {
  enrollmentId: string;
  startDate?: string;
  endDate?: string;
  month?: string;
}) => {
  const response = await apiClient({
    url: appendQueryParams(`/attendance/student/${enrollmentId}`, {
      startDate,
      endDate,
      month,
    }),
    method: "GET",
  });
  return response.data as AttendanceResponse;
};

export { getMyAttendance }